/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createOrderDtoFromDiscriminatorValue, type ErrorResponse, type OrderDto } from '../../../../models/index.js';
// @ts-ignore
import { type XlsxRequestBuilder, XlsxRequestBuilderRequestsMetadata } from './xlsx/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/public/{token}
 */
export interface WithTokenItemRequestBuilder extends BaseRequestBuilder<WithTokenItemRequestBuilder> {
    /**
     * The xlsx property
     */
    get xlsx(): XlsxRequestBuilder;
    /**
     * Returns the order's full details, along with the supplying organization's name, logo and contact details so a reader arriving from an email can tell who the order is with. The {token} is an opaque, time-limited value that binds the organization, customer number, and order id. Any invalid, tampered, or expired token — or a token whose order no longer matches its customer — returns 404, so the endpoint reveals nothing about which check failed.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderDto>}
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {ErrorResponse} error when the service returns a 429 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrderDto | undefined>;
    /**
     * Returns the order's full details, along with the supplying organization's name, logo and contact details so a reader arriving from an email can tell who the order is with. The {token} is an opaque, time-limited value that binds the organization, customer number, and order id. Any invalid, tampered, or expired token — or a token whose order no longer matches its customer — returns 404, so the endpoint reveals nothing about which check failed.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithTokenItemRequestBuilderUriTemplate = "{+baseurl}/api/orders/public/{token}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithTokenItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithTokenItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    xlsx: {
        requestsMetadata: XlsxRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTokenItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithTokenItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
